const txHashRegex = /^0x[a-fA-F0-9]{64}$/

export function isTransactionHash(txHash: any): txHash is string {
  if (typeof txHash !== 'string') return false
  return txHashRegex.test(txHash)
}
